export default [
    {
        path: 'ponto',
        component: () => import(
            '@/views/transporte-paciente/ponto/Index'
        ),
        redirect: 'ponto/list',
        children: [
            {
                name: 'transporte-paciente-ponto-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/ponto/List'
                ),
            },
            {
                name: 'transporte-paciente-ponto-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/ponto/Form'
                ),
            },
            {
                name: 'transporte-paciente-ponto-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/ponto/Form'
                ),
            },
        ],
    },
]